
	
var Template = {

	init: function () {
		$('.layout-builder .component-content[data-component="album"]').each(function(){
			//Template.initAlbum($(this));
		});
	},
    initAlbum: function ($this) {
    	var $album = $this.find('.album-slider');
        $album.slick({
			dots: false,
			arrows: true,
			nav: false,
			infinite: true,
			speed: 500, 
			slidesToShow: 1,
			slidesToScroll: 1,			
	  		cssEase: 'linear',
			prevArrow: PREV_ARROW, 
			nextArrow: NEXT_ARROW, 			
			appendArrows: $album,		
		});
    }
};